import { loginUser, currentUser, signupUser, reauth, logoutUser, getCardForUserId, resetPassword } from "../../feathers";
import { getField, updateField } from "vuex-map-fields";
import moment from 'moment-timezone';


const state = {
    currentUser: null
};

const actions = {
    
    async isSubmissionEnds(){

        const cetTimeNow = moment.tz('Europe/Berlin');
        const cetExpired = moment.tz("2020-04-06 23:59:00", 'Europe/Berlin');
        
        return cetTimeNow.isAfter(cetExpired);
    },

    /**
     * Login user with email and password
     * @param {} param0 
     * @param {String} email 
     * @param {String} password 
     */
    async loginUser({ commit }, { email, password }) {

        const user = await loginUser(email, password);

        commit("updateField", {
            path: "currentUser",
            value: user
        });

        return user;
    },

    async resetPassword(_, email) {
        return await resetPassword(email);
    },

    async logoutUser({ commit }) {

        await logoutUser();

        commit("updateField", {
            path: "currentUser",
            value: null
        });

        commit("profile/updateField", {
            path: "profile",
            value: null
        }, { root: true });
    },

    async signUp({ commit, dispatch }, { email, password, accountId, appSubmissionId }) {

        await signupUser(email, password, accountId, appSubmissionId);

        // dispatch login action 
        const user = await dispatch('loginUser', { email, password });

        commit("updateField", {
            path: "currentUser",
            value: user
        });

        return user;
    },

    /**
     * check if user already autorized before
     * if it is then update the store with the current user
     */
    async checkAuth({ commit }) {
        const user = await currentUser();

        if (user) {
            commit("updateField", {
                path: "currentUser",
                value: user
            })
        } else {
            commit("updateField", {
                path: "currentUser",
                value: null
            })
        }
        return user ? true : false;
    },

    /**
     * Function that tried to authenticate the user 
     * @param {*} param0 
     */
    async authenticate({ commit, dispatch }) {

        let user = await currentUser();

        if (!user) {
            user = await reauth();

            commit("updateField", {
                path: "currentUser",
                value: user
            });

            // if user is logged in 
            // then we need to fetch his full profile (if exists)
            if (user) {
                const { data } = await getCardForUserId(user._id);
                if (data.length > 0) {
                    await dispatch("profile/setProfile", data[0], { root: true });
                } else {
                    commit("profile/updateField", {
                        path: "profile",
                        value: null
                    });
                }
            }

        }


        return { user: user };
    }
};

const mutations = {
    updateField
};

const getters = {
    getField
};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
